import { documentFormSchema } from './documentForm.schema';
import React, { useMemo } from 'react';
import { DataTable } from '../../../../shared/components/patterns';
import EmptyDocumentsState from '@/modules/documents/components/shared/EmptyDocumentsState';
import DocumentStatusBadge from '@/modules/documents/components/shared/DocumentStatusBadge';
import { buildDocumentColumns, buildDocumentRowActions } from './documentsPage.config';

export default function DocumentsTable({
  documents,
  onPreview,
  onViewNotes,
  onDownload,
  onEdit,
  onDelete,
  canManageDocuments = false,
  isLoading = false,
  documentsError = '',
  usingCachedSnapshot = false,
  documentsSnapshotStale = false,
  previewingDocumentId = '',
  onRowClick,
}) {
  const columns = useMemo(() => buildDocumentColumns({ StatusComponent: DocumentStatusBadge }), []);
  const rowActions = useMemo(
    () =>
      buildDocumentRowActions({
        onPreview,
        onViewNotes,
        onEdit,
        onDownload,
        onDelete,
        canManageDocuments,
        documentsSnapshotStale,
        previewingDocumentId,
      }),
    [
      onPreview,
      onViewNotes,
      onEdit,
      onDownload,
      onDelete,
      canManageDocuments,
      documentsSnapshotStale,
      previewingDocumentId,
    ]
  );

  return (
    <section className="documents-table">
      {documentsError ? (
        <div role="alert" className="documents-table__error wt-inline-error">
          {documentsError}
          {usingCachedSnapshot
            ? ' I documenti mostrati non sono live: rappresentano solo uno snapshot locale stale.'
            : ''}
        </div>
      ) : null}
      <DataTable
        ariaLabel="Documenti"
        formSchema={documentFormSchema}
        columns={columns}
        rows={documents}
        getRowId={(document) => document.id}
        loading={isLoading}
        rowActions={rowActions}
        onRowClick={onRowClick}
        emptyState={
          <EmptyDocumentsState
            title={documentsError ? 'Documenti non disponibili' : 'Nessun documento trovato'}
            description={
              documentsError
                ? 'Il backend documents non ha restituito dati validi e non esiste uno snapshot locale utilizzabile.'
                : ''
            }
          />
        }
      />
    </section>
  );
}
